import React, { useEffect, useContext } from 'react'
import { IntlProvider } from 'react-intl'
import Routes from '../Routes'
import { BrowserRouter as Router } from 'react-router-dom'
import { AppContextProvider, AppContext } from '../context/AppContext'
import { PermissionContextProvider } from '../context/PermissionContext'
import { AccessProvider } from '../access/AccessContext'
import { CONFIG } from '../config'

import './main.global.css'
import '../styles/eager-chrome.css'
import '../views/costumer/customerOption.css'
import '../components/loader/style.css'

function LocaleSplash() {
  return (
    <div className="loader-root loader-root--page" role="status" aria-busy="true">
      <div className="loader-content">
        <div className="loader-spinner" aria-hidden="true">
          <span className="loader-spinner__ring" />
          <span className="loader-spinner__ring loader-spinner__ring--accent" />
        </div>
      </div>
    </div>
  )
}

function AppContent(props) {
  const { locale, messages } = useContext(AppContext)
  if (!messages) return <LocaleSplash />

  return (
    <IntlProvider locale={locale} messages={messages}>
      <Router>
        <AccessProvider>
          <Routes token={props.token} />
        </AccessProvider>
      </Router>
    </IntlProvider>
  )
}

function App(props) {
  useEffect(() => {
    console.info(
      `%c🚀 Tech4Inventory %cV${CONFIG.APP.VERSION}`,
      'background: #0B3A6F; color: #ffffff; padding: 4px 8px; border-radius: 4px 0 0 4px; font-weight: 700; font-family: system-ui, sans-serif; font-size: 11px;',
      'background: #10B981; color: #ffffff; padding: 4px 8px; border-radius: 0 4px 4px 0; font-weight: 700; font-family: system-ui, sans-serif; font-size: 11px;',
    )
  }, [])

  return (
    <AppContextProvider>
      <PermissionContextProvider>
        <AppContent token={props} />
      </PermissionContextProvider>
    </AppContextProvider>
  )
}

export default App
